import styled from 'styled-components'

interface IProps {
  Icon: JSX.Element
  title?: string
  details: string
}
const CallAgent = ({ Icon, title, details }: IProps) => {
  return (
    <Div title={title}>
      <i className="call-agent-icon">{Icon}</i>
      <div className="call-initiator-details">
        {title && <span className="call-agent-name">{title}</span>}
        <span className="call-agent-details">{details}</span>
      </div>
    </Div>
  )
}

const Div = styled.div<{ title: string | undefined }>`
  display: flex;
  justify-content: center;
  align-items: center;

  .call-agent-icon {
    border: 1px solid orange;
    margin-right: 1.125rem;
    width: ${({ theme }) => theme.util.pixelToRem(35)};
    height: ${({ theme }) => theme.util.pixelToRem(35)};
    border-radius: 50%;
    overflow: hidden;
    svg {
      width: 100%;
      height: 100%;
    }
  }

  .call-initiator-details {
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.colors.grey.darker};

    .call-agent-name {
      ${({ theme }) => theme.typography.m.normal};
    }

    .call-agent-details {
      font-size: ${({ theme, title }) => (title ? theme.spacing.s : theme.spacing.m)};
      font-weight: ${({ theme, title }) => (title ? theme.fontWeight.normal : theme.fontWeight.bold)};
    }
  }
`

export { CallAgent }
